import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes, SortingDirection } from "enums";
import { type FiltersState, createFiltersSlice } from "features/Application/slices/createFiltersSlice";
import { type EmbeddedVideosFiltersEnum } from "../types/models";

export const initialState: FiltersState<EmbeddedVideosFiltersEnum> = {
  filterOptions: {},
  appliedFilter: {},
  isLoading: false,
  pagination: 1,
  sortingColumnName: undefined,
  sortingDirection: undefined,
};

const embeddedVideosFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.EmbeddedVideos,
    name: "OverviewFilters",
  },
  initialState,
  reducers: {
    setPlainSortingDirection: (state, action: PayloadAction<string>) => {
      state.sortingDirection =
        action.payload.toLowerCase() === "desc" ? SortingDirection.Descending : SortingDirection.Ascending;
    },
  },
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetSearch,
  setSearch,
  setPagination,
  resetPagination,
  setSortingColumnName,
  resetSortingColumnName,
  setSortingDirection,
  setPlainSortingDirection,
  resetSortingDirection,
  resetFilter,
} = embeddedVideosFiltersSlice.actions;

export default embeddedVideosFiltersSlice.reducer;
